import { FC, ImgHTMLAttributes } from 'react';
import cn from 'classnames';

import css from './Image.module.scss';

type ImageProps = {
  src: string;
  alt: string;
} & ImgHTMLAttributes<HTMLImageElement>;

export const Image: FC<ImageProps> = ({
  src,
  alt,
  fetchpriority = 'auto',
  className,
}) => {
  return (
    <img
      src={src}
      fetchpriority={fetchpriority}
      alt={alt}
      className={cn(css.image, className)}
    />
  );
};
